module.exports = __webpack_public_path__ + "img/m3.66c872b1.png";